import {createApp} from 'vue';
import Bookmarking from "@/main/components/Bookmarking.vue";
import {store} from "@/store";
import Fanning from "@/main/components/Fanning.vue";
import RelatedProductsFromAmazon from "@/main/components/RelatedProductsFromAmazon.vue";
import TalentSearch from "@/../Features/Talent/TalentSearch.vue";
import UpgradeToPro from "@/../Features/Membership/UpgradeToPro.vue";
import ChangeProPlan from "@/../Features/Membership/ChangeProPlan.vue";
import CancelMembership from "@/../Features/Membership/CancelMembership.vue";
import ReactivateMembership from "@/../Features/Membership/ReactivateMembership.vue";
import UpdateProfileBasics from "@/../Features//ProfileSettings/UpdateProfileBasics.vue";
import ProfileSkillsSettings from "@/../Features/ProfileSettings/ProfileSkillsSettings.vue";
import UpdateProfileAppearance from "@/../Features/ProfileSettings/UpdateProfileAppearance.vue";
import UpdateProfileCredits from "@/main/components/UpdateProfileCredits.vue";
import ProfileVisibilitySettings from "../Features/ProfileSettings/ProfileVisibilitySettings.vue";
import ProfileRepresentationSettings from "../Features/ProfileSettings/ProfileRepresentationSettings.vue";
import ProfileOutsideLinksSettings from "@/../Features/ProfileSettings/ProfileOutsideLinksSettings.vue";
import UpdateProfileVideos from "@/main/components/UpdateProfileVideos.vue";
import SaLoginDialog from "@/main/components/SaLoginDialog.vue";
import TakeQuiz from "@/main/components/TakeQuiz.vue";
import QuizCard from "@/../Features/Quizzes/QuizCard.vue";
import SubmitCompany from "@/../Features/TheatreCompanies/SubmitCompany.vue";
import OpportunityCard from "@/../Features/Opportunities/OpportunityCard.vue";
import PostAnOpportunity from "@/../Features/Opportunities/PostAnOpportunity.vue";
import MyOpportunities from "@/../Features/MyPosts/MyOpportunities.vue";
import UpdateOpportunity from "@/../Features/MyPosts/UpdateOpportunity.vue";
import Onboarding from "@/../Features/Onboarding/Onboarding.vue";
import ProfileProgress from "@/../Features/ProfileActions/ProfileProgress.vue";
import ProfileProgressNavbar from "@/../Features/ProfileActions/ProfileProgressNavbar.vue";
import NotificationIndicator from "@/main/components/NotificationIndicator.vue";
import FlagContent from "@/../Features/Moderation/FlagContent.vue";
import QrCode from "@/main/components/QrCode.vue";
import SaSocialShare from "@/main/components/SaSocialShare.vue";
import TerritoriesTab from "@/../Features/Territories/TerritoriesTab.vue";
import TerritoriesAutoComplete from "@/../Features/Territories/TerritoriesAutocomplete.vue";
import YourBookmarks from "@/../Features/Bookmarking/YourBookmarks.vue";
import ShowCard from "../Features/Guides/Shows/ShowCard.vue";
import SearchShows from "../Features/Guides/Shows/SearchShows.vue";
import CharacterCard from "../Features/Guides/Characters/CharacterCard.vue";
import SearchCharacters from "../Features/Guides/Characters/SearchCharacters.vue";
import EmptyResultsNotification from "@/main/components/EmptyResultsNotification.vue";
import MonologueCard from "../Features/Guides/Monologues/MonologueCard.vue";
import SearchMonologues from "../Features/Guides/Monologues/SearchMonologues.vue";
import SceneCard from "../Features/Guides/Scenes/SceneCard.vue";
import SearchScenes from "../Features/Guides/Scenes/SearchScenes.vue";
import SongCard from "../Features/Guides/Songs/SongCard.vue";
import SearchSongs from "../Features/Guides/Songs/SearchSongs.vue";
import TheatreCompanyCard from "../Features/TheatreCompanies/TheatreCompanyCard.vue";
import SearchTheatreCompanies from "../Features/TheatreCompanies/SearchTheatreCompanies.vue";
import SearchOpportunities from "../Features/Opportunities/SearchOpportunities.vue";
import SearchTheatreAuditions from "../Features/Auditions/SearchTheatreAuditions.vue";
import WriterCard from "../Features/Guides/Writers/WriterCard.vue";
import SearchWriters from "../Features/Guides/Writers/SearchWriters.vue";
import RecentPostsWidget from "../Features/Blogs/RecentPostsWidget.vue";
import RecentOpportunitiesWidget from "../Features/Opportunities/RecentOpportunitiesWidget.vue";
import OpportunitiesNearMeWidget from "../Features/Opportunities/OpportunitiesNearMeWidget.vue";
import GeneralSearchAutocomplete from "../Features/Search/GeneralSearchAutocomplete.vue";
import GeneralSearch from "../Features/Search/GeneralSearch.vue";
import ShowCardMinimal from "../Features/Guides/Shows/ShowCardMinimal.vue";
import LearningModuleCardMinimal from "../Features/LearningModules/LearningModuleCardMinimal.vue";
import LearningModuleCardStacked from "../Features/LearningModules/LearningModuleCardStacked.vue";
import LearningModuleCard from "../Features/LearningModules/LearningModuleCard.vue";
import BlogPostCard from "../Features/Blogs/BlogPostCard.vue";
import BlogPostCardMinimal from "../Features/Blogs/BlogPostCardMinimal.vue";
import SearchCollegePrograms from "../Features/CollegePrograms/SearchCollegePrograms.vue";
import CollegeProgramCard from "../Features/CollegePrograms/CollegeProgramCard.vue";
import UserPrompt from "@/main/components/UserPrompt.vue";
import RecentShowGuidesWidget from "../Features/Guides/Shows/Recent/RecentShowGuidesWidget.vue";
import WalledOffContent from "../Features/Shared/WalledOffContent.vue";
import OpportunityCardStacked from "../Features/Opportunities/OpportunityCardStacked.vue";
import OpportunityCardMinimal from "../Features/Opportunities/OpportunityCardMinimal.vue";
import SongCardMinimal from "../Features/Guides/Songs/SongCardMinimal.vue";
import ContactUs from "../Features/ContactUs/ContactUs.vue";
import ShowCardStacked from "../Features/Guides/Shows/ShowCardStacked.vue";
import BlogPostCardStacked from "../Features/Blogs/BlogPostCardStacked.vue";
import TalentProfileCard from "../Features/Talent/TalentProfileCard.vue";
import ProfileCustomUrlSettings from "../Features/ProfileSettings/ProfileCustomUrlSettings.vue";
import ProfileHeadshotsSettings from "../Features/ProfileSettings/ProfileHeadshotsSettings.vue";
import ProfileResumeSettings from "../Features/ProfileSettings/ProfileResumeSettings.vue";
import ProfileMessagingSettings from "../Features/Messaging/ProfileMessagingSettings.vue";
import MessageMe from "../Features/Messaging/MessageMe.vue";
import AccountManagerSettings from "../Features/AccountSettings/AccountManagerSettings.vue";
import TalentFavorites from "../Features/Talent/TalentFavorites.vue";
import UpgradeToProCheckout from "../Features/Membership/UpgradeToProCheckout.vue";
import HomeSearchBox from "../Features/Search/HomeSearchBox.vue";
import HeaderSearchBox from "../Features/Search/HeaderSearchBox.vue";
import GetNewestGuides from "../Features/Home/GetNewestGuides.vue";
import Community from "../Features/LandingPages/Community.vue";
import SignUp from "../Features/Signup/SignUp.vue";
import CreateAccount from "../Features/Signup/CreateAccount.vue";
import ForgotPassword from "../Features/Auth/ForgotPassword.vue";
import SignIn from "../Features/Auth/SignIn.vue";
import VueGtag from "vue-gtag";
import SubscriptionPreferences from "../Features/AccountSettings/SubscriptionPreferences.vue";
import ResetPassword from "../Features/Auth/ResetPassword.vue";
import NewsletterSignUp from "../Features/Newsletters/NewsletterSignUp.vue";
import WriterCardMinimal from "../Features/Guides/Writers/WriterCardMinimal.vue";
import WriterCardStacked from "../Features/Guides/Writers/WriterCardStacked.vue";
import CharacterCardMinimal from "../Features/Guides/Characters/CharacterCardMinimal.vue";
import CharacterCardStacked from "../Features/Guides/Characters/CharacterCardStacked.vue";
import MonologueCardMinimal from "../Features/Guides/Monologues/MonologueCardMinimal.vue";
import MonologueCardStacked from "../Features/Guides/Monologues/MonologueCardStacked.vue";
import SceneCardMinimal from "../Features/Guides/Scenes/SceneCardMinimal.vue";
import SceneCardStacked from "../Features/Guides/Scenes/SceneCardStacked.vue";
import SongCardStacked from "../Features/Guides/Songs/SongCardStacked.vue";
import PopularGuides from "../Features/Home/PopularGuides.vue";


// @ts-ignore
window.UPLOADCARE_LOCALE_TRANSLATIONS = {
    errors: {
        fileMaximumSize: 'Oops...File is too large. Maximum allowed file size is 4MB.',
    },
    dialog: {
        tabs: {
            preview: {
                error: {
                    fileMaximumSize: {
                        title: 'Oops...',
                        text: 'File is too large. Maximum allowed file size is 4MB.',
                        back: 'Back',
                    },
                },
            },
        },
    },
}

// @ts-ignore
store.saUserSession.isAuthenticated = window.isAuthenticated ?? false;
// @ts-ignore
store.saUserSession.subscriptionType = window.subscriptionType ?? "non-member";
// @ts-ignore
store.saUserSession.bookmarkedItems = window.bookmarkedItems ?? new Array<string>();
// @ts-ignore
store.saUserSession.fannedItems = window.fannedItems ?? new Array<string>();
// @ts-ignore
store.saUserSession.completedQuizItems = window.completedQuizIds ?? new Array<string>();
// @ts-ignore
store.userMetadata = window.userMetadata ?? {tags: []}

let app = createApp({});
app.use(VueGtag, {
    config: { id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID },
})


app.component("sa-onboarding", Onboarding);
app.component("sa-bookmarking", Bookmarking);
app.component("sa-fanning", Fanning);
app.component("sa-flag-content", FlagContent);
app.component("sa-contact-us", ContactUs);
app.component("sa-talent-search", TalentSearch);
app.component("sa-talent-profile-card", TalentProfileCard);
app.component("sa-related-products-from-amazon", RelatedProductsFromAmazon);
app.component("sa-upgrade-to-pro", UpgradeToPro);
app.component("sa-upgrade-to-pro-checkout", UpgradeToProCheckout);
app.component("sa-change-pro-plan", ChangeProPlan);
app.component("sa-cancel-membership", CancelMembership);
app.component("sa-reactivate-membership", ReactivateMembership);
app.component("sa-update-profile-basics", UpdateProfileBasics);
app.component("sa-profile-skills-settings", ProfileSkillsSettings);
app.component("sa-account-manager-settings", AccountManagerSettings);
app.component("sa-subscription-preferences", SubscriptionPreferences);
app.component("sa-update-profile-appearance", UpdateProfileAppearance);
app.component("sa-update-profile-credits", UpdateProfileCredits);
app.component("sa-profile-outside-links-settings", ProfileOutsideLinksSettings);
app.component("sa-profile-representation-settings", ProfileRepresentationSettings);
app.component("sa-profile-custom-url-settings", ProfileCustomUrlSettings);
app.component("sa-profile-headshots-settings", ProfileHeadshotsSettings);
app.component("sa-profile-resume-settings", ProfileResumeSettings);
app.component("sa-profile-visibility-settings", ProfileVisibilitySettings);
app.component("sa-profile-messaging-settings", ProfileMessagingSettings);
app.component("sa-update-profile-videos", UpdateProfileVideos);
app.component("sa-message-me", MessageMe);
app.component("sa-login-dialog", SaLoginDialog);
app.component("sa-user-prompt", UserPrompt);
app.component("sa-take-quiz", TakeQuiz);
app.component("sa-quiz-card", QuizCard);
app.component("sa-submit-company", SubmitCompany);
app.component("sa-opportunity-card", OpportunityCard);
app.component("sa-opportunity-card-stacked", OpportunityCardStacked);
app.component("sa-opportunity-card-minimal", OpportunityCardMinimal);
app.component("sa-search-opportunities", SearchOpportunities);
app.component("sa-search-theatre-auditions", SearchTheatreAuditions);
app.component("sa-post-an-opportunity", PostAnOpportunity);
app.component("sa-update-opportunity", UpdateOpportunity);
app.component("sa-my-opportunities", MyOpportunities);
app.component("sa-profile-progress", ProfileProgress);
app.component("sa-profile-progress-navbar", ProfileProgressNavbar);
app.component("sa-notification-indicator", NotificationIndicator);
app.component("sa-qr-code", QrCode);
app.component("sa-social-share", SaSocialShare);
app.component("sa-territories-tab", TerritoriesTab);
app.component("sa-territories-auto-complete", TerritoriesAutoComplete);
app.component("sa-your-bookmarks", YourBookmarks);
app.component("sa-show-card", ShowCard);
app.component("sa-show-card-stacked", ShowCardStacked);
app.component("sa-show-card-minimal", ShowCardMinimal);
app.component("sa-search-shows", SearchShows);
app.component("sa-character-card", CharacterCard);
app.component("sa-character-card-minimal", CharacterCardMinimal);
app.component("sa-character-card-stacked", CharacterCardStacked);
app.component("sa-search-characters", SearchCharacters);
app.component("sa-monologue-card", MonologueCard);
app.component("sa-monologue-card-minimal", MonologueCardMinimal);
app.component("sa-monologue-card-stacked", MonologueCardStacked);
app.component("sa-search-monologues", SearchMonologues);
app.component("sa-scene-card", SceneCard);
app.component("sa-scene-card-minimal", SceneCardMinimal);
app.component("sa-scene-card-stacked", SceneCardStacked);
app.component("sa-search-scenes", SearchScenes);
app.component("sa-song-card", SongCard);
app.component("sa-song-card-minimal", SongCardMinimal);
app.component("sa-song-card-stacked", SongCardStacked);
app.component("sa-search-songs", SearchSongs);
app.component("sa-theatre-company-card", TheatreCompanyCard);
app.component("sa-search-theatre-companies", SearchTheatreCompanies);
app.component("sa-empty-results", EmptyResultsNotification);
app.component("sa-writer-card", WriterCard);
app.component("sa-writer-card-minimal", WriterCardMinimal);
app.component("sa-writer-card-stacked", WriterCardStacked);
app.component("sa-search-writers", SearchWriters);
app.component("sa-recent-posts-widget", RecentPostsWidget);
app.component("sa-recent-opportunities-widget", RecentOpportunitiesWidget);
app.component("sa-opportunities-near-me-widget", OpportunitiesNearMeWidget);
app.component("sa-general-search-autocomplete", GeneralSearchAutocomplete);
app.component("sa-general-search", GeneralSearch);
app.component("sa-learning-module-card", LearningModuleCard);
app.component("sa-learning-module-card-minimal", LearningModuleCardMinimal);
app.component("sa-learning-module-card-stacked", LearningModuleCardStacked);
app.component("sa-blog-post-card", BlogPostCard);
app.component("sa-blog-post-card-stacked", BlogPostCardStacked);
app.component("sa-blog-post-card-minimal", BlogPostCardMinimal);
app.component("sa-search-college-programs", SearchCollegePrograms);
app.component("sa-college-program-card", CollegeProgramCard);
app.component("sa-recent-show-guides-widget", RecentShowGuidesWidget);
app.component("sa-newest-guides", GetNewestGuides);
app.component("sa-walled", WalledOffContent);
app.component("sa-talent-favorites", TalentFavorites);
app.component("sa-home-search-box", HomeSearchBox);
app.component("sa-home-popular-guides", PopularGuides);
app.component("sa-header-search-box", HeaderSearchBox);
app.component("sa-community-page", Community);
app.component("sa-sign-up", SignUp);
app.component("sa-create-account", CreateAccount);
app.component("sa-signin", SignIn);
app.component("sa-forgot-password", ForgotPassword);
app.component("sa-reset-password", ResetPassword);
app.component("sa-newsletter-signup", NewsletterSignUp);
app.mount('#app');
